export default "__VITE_ASSET__DweRqEeV__"